import React, { useEffect } from 'react';
import Tab from '../../../Components/Tab/Tab';
import './Menu.scss';
import { alertRef } from '../../../App';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const routeList = {
    '/order/menu': '메뉴관리',
    '/order/option' : '옵션관리',
    '/order/soldout/menu' : '메뉴품절관리',
    '/order/soldout/option' : '옵션품절관리',
    '/order/menu-image' : '메뉴이미지관리',
    '/order/intro' : '매장안내·원산지'
}

const Menu = (props) => {
    const [ name, setName ] = React.useState('store-info')
    const route = useSelector((state) => state.user.route)
    const navigate = useNavigate();
    
    const tabRoute = [
        { route : 'menu', header : '메뉴관리' },
        { route : 'option', header : '옵션관리' },
        { route : 'soldout/menu', header : '메뉴품절관리' },
        { route : 'soldout/option', header : '옵션품절관리' },
        { route : 'menu-image', header : '메뉴이미지관리' },
        { route : 'intro', header : '매장안내·원산지' },
    ]

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>오더 {'>'} 메뉴관리 {'>'}</p>
                <p className='header-name'>{routeList[route]}</p>
            </div>
            <Tab 
                routes={tabRoute}
                current={route.replace('/order/','')}
                onTabChange={(name) => {setName(name);navigate(`/order/${name}`)}}
                renderItems={{
                    'menu' : <Outlet/>,
                    'option' : <Outlet/>,
                    'soldout/menu' : <Outlet />,
                    'soldout/option' : <Outlet />,
                    'menu-image' : <Outlet />,
                    'intro' : <Outlet />,
                }}
            />
        </div>
    )
}

export default Menu;